export const readStoredReservation = () => {
	try {
		const raw = sessionStorage.getItem("reservation:last");
		return raw ? JSON.parse(raw) : null;
	} catch (_) {
		return null;
	}
};

// Beauty rows also carry durationMinutes>0, so beauty must be detected
// explicitly before the court heuristic.
export const isBeautyReservation = (reservation) =>
	reservation?.kind === "beauty" || reservation?.flow === "beauty";

export const isCourtReservation = (reservation) =>
	!isBeautyReservation(reservation) &&
	(Number(reservation?.durationMinutes) > 0 || Boolean(reservation?.sport));

const getExplicitReservationKind = (reservation) => {
	if (isBeautyReservation(reservation)) return "beauty";
	if (reservation?.flow === "canchas") return "court";
	if (reservation?.flow === "reservas") return "table";
	if (isCourtReservation(reservation)) return "court";
	return null;
};

export const getReservationKind = ({
	statusInfo,
	queryReservation,
	storedReservation,
}) => {
	if (statusInfo) {
		if (isBeautyReservation(statusInfo)) return "beauty";
		return isCourtReservation(statusInfo) ? "court" : "table";
	}

	const queryKind = getExplicitReservationKind(queryReservation);
	if (queryKind) return queryKind;

	return getExplicitReservationKind(storedReservation) || "table";
};
